import styled from '@emotion/styled'

export const ProgressBarImage = styled.img`
  height: 10px;
  width: 100%;
`
